import { useEffect } from 'react';
var useSafariModalWorkaround = (isModalOpen, isEnabled) => {
  var isSafari = typeof navigator === 'undefined' ? false : /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  useEffect(() => {
    if (isSafari && isEnabled) {
      if (isModalOpen) {
        document.body.style.position = 'fixed';
        if (typeof window !== 'undefined') {
          document.body.style.top = "-".concat(window.scrollY, "px");
        }
      } else {
        var scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        if (typeof window !== 'undefined') {
          window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
        }
      }
    }
  }, [isSafari, isEnabled, isModalOpen]);
};
export default useSafariModalWorkaround;